import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, of, } from 'rxjs';
import { CentroOperacionByID, Co, ResponseCo } from '../interfaces/co.interface';


@Injectable({providedIn: 'root'})
export class CoService {

  private baseUrl: string = environment.baseUrlAuth;
  private baseUrlJS: string = environment.baseUrl;

  constructor(private http: HttpClient) { }

  private getAuthHeaders(): { headers: HttpHeaders; params: HttpParams } {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    });

    const params = new HttpParams().set('like', 'true').set('limitMax', '20');

    return { headers, params };
  }

  addCo( co: Co ): Observable<Co> {
    return this.http.post<Co>(`${this.baseUrlJS}/centrosOperacion`, co)
  }

  getCoList(): Observable<Co[]> {
    return this.http.get<Co[]>(`${this.baseUrlJS}/centrosOperacion`);
  }

  getCoListActivo(): Observable<Co[]> {
    return this.http.get<Co[]>(`${this.baseUrlJS}/centrosOperacion`)
    .pipe(
      map((coList: Co[]) => coList.filter(co => co.state === 'Activo'))
    )
  }

  getCo(id: string): Observable<Co> {
    return this.http.get<Co>(`${this.baseUrlJS}/centrosOperacion/${id}`);
  }

  updateCo(id: string, data: any): Observable<Co> {
    return this.http.patch<Co>(`${this.baseUrlJS}/centrosOperacion/${id}`, data)
  }

  deleteCo(id: string): Observable<boolean> {
    return this.http.delete(`${this.baseUrlJS}/centrosOperacion/${id}`)
      .pipe(
        map( resp => true ),
        catchError ( err => of(false))
      )
  }

  // Crear funcion para no repetir el const authToken y headers en cada servicio

  getCoById(id: string): Observable<ResponseCo> {
    const apiUrl = `${this.baseUrl}/api/centros-operacion/${id}`;
    const {headers, params } = this.getAuthHeaders();

    return this.http.get<ResponseCo>(apiUrl, { headers });
  }

  getCoByID(id: string): Observable<CentroOperacionByID[]> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    const params = new HttpParams()
      .set('like', 'true')
      .set('limitMax', '20');

    return this.http.get<CentroOperacionByID[]>(`${this.baseUrl}/api/centros-operacion/${id}`, {params, headers });
  }


}
